@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.receipt-container {
  margin-bottom: 2.625rem;
}

.receipt-input-headline {
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  font-weight: 200;

  @include mobile {
    margin-bottom: 0.25rem;
    font-size: 1.125rem;
  }
}

.success-message {
  font-weight: 600;
  margin-top: .5rem;
}

.text {
  font-size: 1rem;
  line-height: 1.5rem;
  color: $grey-text;
  font-weight: 300;

  @include mobile {
    font-size: 0.75rem;
    line-height: 1.125rem;
  }
}

.input-wrapper {
  display: flex;
  flex-direction: row;
  width: 70%;
  margin: 2.625rem auto 0 auto;
  align-items: end;

  button {
    line-height: 1.5rem;
    font-size: 1.125rem;
    // fixes button width for IE
    width: 19%;

    @include mobile {
      font-size: 1rem;
    }
  }

  @include mobile {
    width: 100%;
    margin: 1.5rem auto 0 auto;
  }
}

.button-spacer {
  width: 4%;
  height: 100%;
}

.error-wrapper {
  div {
    margin-top: 1rem;
    margin-left: auto;
    margin-right: auto;
  }
}